<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Novo Número Proibido</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Cadastre um novo número bloqueado com observação opcional para controle das operações.</p>
        </div>
        <button
          type="button"
          class="icon-anim-trigger--back group flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md sm:w-auto"
          @click="voltar"
        >
          <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          Voltar
        </button>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm md:p-5">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">Número</label>
            <input
              v-model="numero"
              type="text"
              placeholder="Ex: 11999999999"
              class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div class="flex flex-col gap-1 md:col-span-2">
            <label class="text-sm font-medium text-gray-500">Observação</label>
            <textarea
              v-model="observacao"
              rows="4"
              placeholder="Opcional"
              class="rounded-xl border border-gray-200 px-4 py-2 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
        <button type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 hover:shadow-md" @click="voltar">Cancelar</button>

        <button type="button" class="h-11 rounded-xl bg-blue-500 px-5 font-medium text-white shadow-sm transition hover:bg-blue-600" @click="salvar">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numero: "",
      observacao: ""
    };
  },
  methods: {
    voltar() {
      this.$router.push({ name: "OperadoresNumerosProibido" });
    },
    async salvar() {
      if (!this.numero.trim()) {
        this.$vToastify.error("Informe o número");
        return;
      }

      try {
        const resp = await this.$http.post("/v1/numeros-proibidos/new", {
          numero: this.numero.trim(),
          observacao: this.observacao.trim()
        });

        if (!resp.data.success) {
          this.$vToastify.error(resp.data.err || "Erro ao salvar");
          return;
        }

        this.$vToastify.success("Número cadastrado");
        this.$router.push({ name: "OperadoresNumerosProibido" });
      } catch (err) {
        console.error(err);
        this.$vToastify.error("Erro ao salvar número");
      }
    }
  }
};
</script>
